import { useEffect, useRef, useState } from "react";

const VIDEO_URL = "/intro.mp4";

export const SplashIntro = () => {
  const [open, setOpen] = useState(true);
  const [closing, setClosing] = useState(false);
  const timers = useRef([]);

  const close = () => {
    setClosing((c) => {
      if (c) return c;
      timers.current.push(setTimeout(() => setOpen(false), 420));
      return true;
    });
  };

  useEffect(() => {
    if (!open) return;
    const maxTimer = setTimeout(close, 26000); // safety: mai bloccati
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(maxTimer);
      timers.current.forEach(clearTimeout);
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="splash-intro"
      onClick={close}
      className="fixed inset-0 z-[100] overflow-hidden cursor-pointer flex items-center justify-center"
      style={{
        background: "radial-gradient(circle at 50% 45%, #14140f 0%, #050505 70%)",
        opacity: closing ? 0 : 1,
        transition: "opacity 0.42s cubic-bezier(0.4, 0, 0.2, 1)",
        willChange: "opacity",
      }}
    >
      <video
        src={VIDEO_URL}
        autoPlay
        muted
        playsInline
        onEnded={close}
        onError={close}
        className="w-full h-full object-contain pointer-events-none"
      />

      <button
        data-testid="splash-enter-btn"
        onClick={(e) => { e.stopPropagation(); close(); }}
        className="group absolute z-20 bottom-24 left-1/2 -translate-x-1/2 flex items-center gap-3 border border-[#F0EEE9]/60 text-[#F0EEE9] px-8 py-3.5 font-mono2 text-xs uppercase tracking-[0.3em] bg-black/30 backdrop-blur-sm hover:bg-[#F0EEE9] hover:text-[#0A0A0A] transition-colors"
      >
        Entra
        <span className="inline-block group-hover:translate-x-1 transition-transform">→</span>
      </button>
    </div>
  );
};
